import {
  ListUpgradeAssessmentsResponse,
  UpgradeAssessmentStatus,
  UpgradeUser,
} from 'api/admin-models';

export interface UpgradeAssessmentsTableElement {
  AccountId: string;
  Id: string;
  Name: string;
  Environment?: string;
  ClusterId: string;
  Status: UpgradeAssessmentStatus;
  RequestedBy?: UpgradeUser;

  Created: number;
  Updated?: number;
}

export function fromApiResponses(
  data: ListUpgradeAssessmentsResponse[] | undefined,
): UpgradeAssessmentsTableElement[] | undefined {
  if (data === undefined) {
    return undefined;
  }

  const results = data.reduce<UpgradeAssessmentsTableElement[]>((acc, res) => {
    const mappedData = res.data.map<UpgradeAssessmentsTableElement>((uav) => ({
      AccountId: uav.account_id,
      Id: uav.upgrade_assessment.id,
      Name: uav.upgrade_assessment.name,
      Environment: uav.upgrade_assessment.environment,
      ClusterId: uav.upgrade_assessment.resources.clusters?.[0]?.id || '',
      Status: uav.upgrade_assessment.status,
      Created: uav.upgrade_assessment.created,
      Updated: uav.upgrade_assessment.updated,
      RequestedBy: uav.upgrade_assessment.requested_by,
    }));

    return acc.concat(...mappedData);
  }, []);

  return results;
}
